// @ts-nocheck
import { useEffect, useState } from 'react';
import config from './configration.json';
import { Button, Slider, SliderRange, Input, Checkbox, Textarea, Select, SelectOption, Tabs } from '@/components/ui/form';
import { useAudioListStore } from '@/state/audio-list-store';
import { useForm } from 'react-hook-form';
import AudioList from '../Home/components/AudioList';
import { postSuperTesterAudioGenerate, postSuperTesterAudioComposeGenerate, getAudioDetail } from '@/service/generatorv2';
import { useRequest } from 'ahooks';
import { toast } from 'sonner';
import { useSessionStore } from '@/hooks/useSessionStore';
import { useAuthCheck } from '@/hooks/useAuthCheck';
import { getStyleFilterList, getInternalStyleFilterList } from '@/service/filter';
import { useStyleFilterStore } from '@/state/style-filter-list-store';
import { useModel } from '../Home/Generator/model';
import { useClipboard } from 'use-clipboard-copy';

const filterTIArrayModels = [
  'jen_20-DiT-base-v20250514-all-a2a_skip-rag-c',
  'jen_20-DiT-base-v20250514-all-features-rag-c',
  'jen_20-DiT-base-v20250514-all-features-debug-rag-c',
  'jen_20-DiT-base-v20250630-ipadapter-mert-c',
  'jen_21-DiT-base-v202506011-guitar-c',
];
const sparseRatioModels = [
  'jen_20-DiT-base-v20250514-all-a2a_skip-rag-c',
  'jen_20-DiT-base-v20250514-all-features-rag-c',
  'jen_20-DiT-base-v20250530-all-unienc-rag-c',
  'jen_20-DiT-base-v20250514-all-features-debug-rag-c',
  'jen_20-DiT-base-v20250630-ipadapter-mert-c',
  'jen_21-DiT-base-v202506011-guitar-c',
];

const promptListModel = [
  'jenxl_prompts_v20241206_c20241112-ROPE_c',
  'jen2_fm_unienc_v20250209',
  'jen2_fm_multienc_v20250209',
  'jen2_dit_multienc_v20250209',
  'jen2_dit_multienc_v20250310',
  'jen2_small_fm_unienc_v20250310',
];

const promptListModelNoNotTime = [
  'jen2_fm_unienc_v20250209',
  'jen2_fm_multienc_v20250209',
  'jen2_dit_multienc_v20250209',
  'jen2_dit_multienc_v20250310',
  'jen2_small_fm_unienc_v20250310',
];

const defaultValues = {
  transition_length: 10,
  prompt_list: [
    {
      prompt: '',
      not_time: [0, 5],
    },
    {
      prompt: '',
      not_time: [5, 10],
    },
    {
      prompt: '',
      not_time: [10, 15],
    },
    {
      prompt: '',
      not_time: [15, 20],
    },
    {
      prompt: '',
      not_time: [20, 25],
    },
  ],
} as any;

config.map((i) => {
  defaultValues[i.key] = i.default_value;
});

const SuperTester = () => {
  useModel();
  const sessionStore = useSessionStore();
  const { session } = sessionStore;
  const { isAuth } = useAuthCheck();
  const clipboard = useClipboard();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const { selectedInfo } = useAudioListStore();
  const [formData, setFormData] = useState(defaultValues);
  const [genreStylefilter, setGenreStylefilter] = useState([]);
  const [audioDetail, setAudioDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('live');
  const [superTesterStore, setSuperTesterStore] = useState<JSON[]>([]);
  const { setStyleFilterList } = useStyleFilterStore();
  const [afterStyleFilterFilterList, setAfterStyleFilterFilterList] = useState([]);

  const { run: runPostAudioGenerate, loading: generatorTextLoading } = useRequest(postSuperTesterAudioGenerate, {
    manual: true,
    onSuccess: (data) => {},
    onError: (error) => {
      toast.error(String(error) ?? 'Unknown Error.');
    },
    debounceWait: 500,
  });

  const { run: runPostAudioComposeGenerate, loading: composeGeneratorTextLoading } = useRequest(postSuperTesterAudioComposeGenerate, {
    manual: true,
    onSuccess: (data) => {},
    onError: (error) => {
      toast.error(String(error) ?? 'Unknown Error.');
    },
    debounceWait: 500,
  });

  const onSubmitCompose = (v: any) => {
    console.log(v);
    const postFormData = new FormData();
    const filesCodes = [] as string[];
    if (v.drums[0]) {
      filesCodes.push('Drums');
      postFormData.append('files', v.drums[0]);
    }
    if (v.bass[0]) {
      filesCodes.push('Bass');
      postFormData.append('files', v.bass[0]);
    }
    if (v.guitar[0]) {
      filesCodes.push('Guitar');
      postFormData.append('files', v.guitar[0]);
    }
    if (v.other[0]) {
      filesCodes.push('Other');
      postFormData.append('files', v.other[0]);
    }
    if (filesCodes.length !== 3) return;

    const target_track = ['Drums', 'Bass', 'Guitar', 'Other'].filter((item) => !filesCodes.includes(item))[0];
    postFormData.append('files_codes', filesCodes);
    postFormData.append('target_track', target_track);
    postFormData.append('prompt', v.prompt);
    postFormData.append('model', formData.model);
    runPostAudioComposeGenerate(postFormData);
  };

  const onSubmit = () => {
    const copyFormData = { ...formData };
    if (promptListModel.includes(copyFormData.model) && copyFormData.assist && copyFormData?.prompt_list)
      copyFormData.prompt = copyFormData.prompt_list[0].prompt;
    if (copyFormData?.prompt_list) copyFormData.prompt_list = copyFormData.prompt_list.filter((i) => !!i.prompt);
    const submitData =
      promptListModel.includes(copyFormData.model) && !copyFormData.assist
        ? {
            ...copyFormData,
            prompt: '',
          }
        : {
            ...copyFormData,
            prompt_list: null,
          };

    if (submitData.genre_stylefilter) {
      submitData.stylefilter = submitData.genre_stylefilter;
    }

    // handle filterTI array for specific models
    if (filterTIArrayModels.includes(copyFormData.model)) {
      if (copyFormData.stylefilter) {
        submitData.filterTI = [
          copyFormData.filterTI,
          copyFormData.filterTI_genres,
          copyFormData.filterTI_instruments,
          copyFormData.filterTI_key,
        ];
      }
      if (copyFormData.stylefilter_2) {
        submitData.filterTI_2 = [
          copyFormData.filterTI_2,
          copyFormData.filterTI_2_genres,
          copyFormData.filterTI_2_instruments,
          copyFormData.filterTI_2_key,
        ];
      }
    }
    // handle filter_load_sparse_ratio for specific models
    if (sparseRatioModels.includes(copyFormData.model)) {
      if (copyFormData.stylefilter && copyFormData.stylefilter_2) {
        submitData.filter_load_sparse_ratio = [copyFormData.filter_load_sparse_ratio_1, copyFormData.filter_load_sparse_ratio_2];
      } else {
        if (copyFormData.stylefilter) {
          submitData.filter_load_sparse_ratio = copyFormData.filter_load_sparse_ratio_1;
        } else if (copyFormData.stylefilter_2) {
          submitData.filter_load_sparse_ratio = copyFormData.filter_load_sparse_ratio_2;
        }
      }
    }
    // handle soulmate_method only avaible when both SF is selected
    if (!(copyFormData.stylefilter && copyFormData.stylefilter_2)) {
      delete submitData.soulmate_method;
    }

    let submitPayload = {
      type,
      ...submitData,
      audioId: type === 'live' ? null : copyFormData.audioId,
    };
    const useFormData = Boolean(copyFormData.audio_reference);
    if (useFormData) {
      delete submitPayload.audio_reference;
      const formData = new FormData();
      Object.entries(submitPayload).forEach(([key, value]) => {
        // convert non-string types to JSON strings (for objects or nulls)
        formData.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      });
      formData.append('files', copyFormData.audio_reference);
      submitData.audio_reference = null;
      submitPayload = formData;
    }

    runPostAudioGenerate(
      useFormData
        ? submitPayload
        : {
            data: submitPayload,
          },
    );
  };

  useEffect(() => {
    const config = localStorage.getItem('super_tester_store') as string | null;
    if (config) setSuperTesterStore(JSON.parse(config));
  }, []);

  useEffect(() => {
    if (type === 'live') {
      setFormData({
        ...formData,
        model: 'jen_20-DiT-base-v20250514-all-features-rag-c',
        steps: 100,
        ragAudio2Audio: true,
      });
    } else if (type === 'extend') {
      setFormData({
        ...formData,
        model: 'jen_20-DiT-base-v20250514-all-features-rag-c',
        steps: 30,
        ragAudio2Audio: false,
      });
    } else if (type === 'intro') {
      setFormData({
        ...formData,
        model: 'jen_20-DiT-base-v20250514-all-features-rag-c',
        steps: 30,
        ragAudio2Audio: false,
      });
    } else if (type === 'outro') {
      setFormData({
        ...formData,
        model: 'jen_20-DiT-base-v20250514-all-features-rag-c',
        steps: 30,
        ragAudio2Audio: false,
      });
    } else if (type === 'inpaint') {
      setFormData({
        ...formData,
        model: 'jen_20-DiT-base-v20250514-all-features-rag-c',
        steps: 30,
        ragAudio2Audio: false,
      });
    } else if (type === 'transition') {
      setFormData({
        ...formData,
        prompt: 'transition',
        model: 'jen_16-base-v20241206-inpaint20241217-feature_transition',
      });
    }
  }, [type]);

  useEffect(() => {
    (async () => {
      const res = await getStyleFilterList();
      setAfterStyleFilterFilterList(
        res.data
          .filter(
            (i) =>
              (i.code.startsWith('IMO-') || i.name.startsWith('TEST_') || i.name.startsWith('AL_') || i.name.startsWith('ES_')) &&
              !['IMO-GNG-HIGH', 'IMO-HEADLOCK-HIGH', 'IMO-JFN-HIGH', 'IMO-LNE-HIGH', 'IMO-WHYDTM-HIGH'].includes(i.code),
          )
          .sort((a, b) => {
            const getPriority = (name: string) => {
              if (name.startsWith('TEST_JEN_20_LNE_IP_MERT')) return -6;
              if (name.startsWith('TEST_JEN_20_HEADLOCK_IP_MERT_ALL_LORA')) return -5;
              if (name.startsWith('TEST_JEN_20_WHYDTM_IP_MERT_ALL_LORA')) return -4;
              if (name.startsWith('TEST_JEN_20_GNG_IP_MERT_ALL_LORA')) return -3;
              if (name.startsWith('TEST_JEN_20_JFN_IP_MERT_ALL_LORA')) return -2;
              if (name.startsWith('TEST_JEN_20_GENRE_SF')) return -1;
              return 0;
            };
            return getPriority(a.name) - getPriority(b.name);
          }),
      );
    })();
  }, [selectedInfo]);

  useEffect(() => {
    (async () => {
      if (!selectedInfo) return;
      const { data } = await getAudioDetail({ id: selectedInfo.id });
      setAudioDetail(data);
      const metadata = data.metadata;
      setFormData({
        ...formData,
        seed: formData.seed,
        audioId: selectedInfo.id,
        original_audio_duration: selectedInfo.duration,
      });
    })();
  }, [selectedInfo]);

  if (!isAuth || !session.user.permissions.find((i) => i.code === 'VIEW_SUPER_TESTER')) {
    return null;
  }

  return (
    <div className={'flex h-lvh'}>
      <div className="flex-1 px-2 pt-2 h-lvh overflow-y-auto relative">
        <div className="mb-4 flex gap-2">
          <Tabs
            className="px-0 mx-0"
            data={[
              { label: 'Generate', key: 'live' },
              { label: 'Extend', key: 'extend' },
              { label: 'Intro', key: 'intro' },
              { label: 'Outro', key: 'outro' },
              { label: 'Refill', key: 'inpaint' },
              { label: 'Reimagine', key: 'reimagine_track' },
              { label: 'Transition', key: 'transition' },
              { label: 'Compose', key: 'compose' },
            ]}
            onChange={(v) => {
              const modelOptions = config.find((i) => i.key === 'model');
              setFormData({
                ...formData,
                keep_times: ['intro', 'outro'].includes(v) ? 10 : v === 'extend' ? 5 : null,
                model: modelOptions.options[v][0],
              });
              setLoading(true);
              setType(v);
              setTimeout(() => {
                setLoading(false);
              }, 100);
            }}
          />
        </div>
        {type === 'compose' && (
          <form onSubmit={handleSubmit(onSubmitCompose)}>
            <Button>Generate</Button>
            {!loading && (
              <>
                <div className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>prompt:</div>
                  <div className={'flex-1 content-center'}>
                    <div className={'flex-1'}>
                      <Textarea
                        rows={4}
                        {...register('prompt')}
                        defaultValue={''}
                        value={formData.prompt}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            prompt: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div key={'model'} className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>model:</div>
                  <div className={'flex-1 content-center'}>
                    <div>
                      <Select
                        value={formData['model']}
                        {...register('model')}
                        onValueChange={(v) => {
                          setFormData({
                            ...formData,
                            ['model']: v,
                          });
                        }}
                      >
                        <>
                          {config[0].options[type]?.map((option) => (
                            <SelectOption key={option} value={option} label={option}></SelectOption>
                          ))}
                        </>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>Drums:</div>
                  <div className={'flex-1 content-center'}>
                    <div className={'flex-1'}>
                      <Input type="file" {...register('drums')} />
                    </div>
                  </div>
                </div>
                <div className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>Bass:</div>
                  <div className={'flex-1 content-center'}>
                    <div className={'flex-1'}>
                      <Input type="file" {...register('bass')} />
                    </div>
                  </div>
                </div>
                <div className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>Guitar:</div>
                  <div className={'flex-1 content-center'}>
                    <div className={'flex-1'}>
                      <Input type="file" {...register('guitar')} />
                    </div>
                  </div>
                </div>
                <div className={'flex gap-2 mb-2'}>
                  <div className={'w-56 text-right leading-10'}>Other:</div>
                  <div className={'flex-1 content-center'}>
                    <div className={'flex-1'}>
                      <Input type="file" {...register('other')} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </form>
        )}
        {type !== 'compose' && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Button>Generate</Button>
            {!loading && (
              <>
                {!['live', 'transition'].includes(type) && (
                  <>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>audio_id:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['audioId']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['audioId']: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>original_audio_duration:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['original_audio_duration']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['original_audio_duration']: +e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {['transition'].includes(type) && (
                  <>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>former_id:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['former_id']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['former_id']: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>latter_id:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['latter_id']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['latter_id']: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>transition_length:</div>
                      <div className={'flex-1 content-center'}>
                        <div>
                          <Input
                            defaultValue={defaultValues.transition_length}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                ['transition_length']: +e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {['intro', 'outro', 'extend'].includes(type) && (
                  <>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>keep_times:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['keep_times']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['keep_times']: +e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {['inpaint'].includes(type) && (
                  <>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>inpaint_start:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['inpaint_start']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['inpaint_start']: +e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>inpaint_end:</div>
                      <div className={'flex-1 content-center'}>
                        <Input
                          value={formData['inpaint_end']}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ['inpaint_end']: +e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {promptListModel.includes(formData.model) && (
                  <>
                    {formData.prompt_list.map((p, index) => {
                      if (formData.assist && index !== 0) return null;
                      return (
                        <>
                          <div className={'flex gap-2 mb-2'}>
                            <div className={'w-56 text-right leading-10'}>prompt {index + 1}:</div>
                            <div className={'flex-1 content-center'}>
                              <div className={'flex-1'}>
                                <Textarea
                                  rows={2}
                                  defaultValue={''}
                                  value={p.prompt}
                                  onChange={(e) => {
                                    const prompt_list = formData.prompt_list;
                                    prompt_list[index].prompt = e.target.value;
                                    setFormData({
                                      ...formData,
                                      prompt_list: prompt_list,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          {!promptListModelNoNotTime.includes(formData.model) && (
                            <div className={'flex gap-2 mb-2'}>
                              <div className={'w-56 text-right leading-10'}>not_time {index + 1}:</div>
                              <div className={'flex-1 content-center'}>
                                <div className={'flex-1'}>
                                  <div className={'flex'}>
                                    <div className={'w-24 text-left'}>
                                      [{p.not_time[0]},{p.not_time[1]}]
                                    </div>
                                    <div className={'flex-1'}>
                                      <SliderRange
                                        max={formData.length}
                                        min={0}
                                        step={1}
                                        defaultValue={p.not_time}
                                        value={p.not_time}
                                        onChange={(value: number[]) => {
                                          const prompt_list = formData.prompt_list;
                                          if (prompt_list[index + 1] && prompt_list[index + 1].not_time[0] < value[1]) {
                                            return;
                                          }
                                          if (prompt_list[index - 1]) {
                                            prompt_list[index - 1].not_time[1] = value[0];
                                          }
                                          if (value[1] - value[0] < 5) return;
                                          prompt_list[index].not_time = value;
                                          setFormData({
                                            ...formData,
                                            prompt_list: prompt_list,
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                  </>
                )}
                {!['transition'].includes(type) && !promptListModel.includes(formData.model) && (
                  <div className={'flex gap-2 mb-2'}>
                    <div className={'w-56 text-right leading-10'}>prompt:</div>
                    <div className={'flex-1 content-center'}>
                      <div className={'flex-1'}>
                        <Textarea
                          rows={4}
                          defaultValue={''}
                          value={formData.prompt}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              prompt: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {config.map((i) => {
                  if (i.hide) return;
                  if (i.showOnMultiTI && !filterTIArrayModels.includes(formData.model)) return;
                  if (i.showSparseRatio && !sparseRatioModels.includes(formData.model)) return;
                  return (
                    <div key={i.key} className={'flex gap-2 mb-2'}>
                      <div className={'w-56 text-right leading-10'}>{i.lable}:</div>
                      <div className={'flex-1 content-center'}>
                        {i.type === 'textarea' && (
                          <div className={'flex-1'}>
                            <Textarea
                              rows={4}
                              defaultValue={String(i.default_value || '')}
                              value={formData[i.key]}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  [i.key]: e.target.value,
                                });
                              }}
                            />
                          </div>
                        )}

                        {i.type === 'slider' && (
                          <div key={i.key} className={'flex'}>
                            <div className={'w-8 text-left'}>{formData[i.key]}</div>
                            <div className={'flex-1'}>
                              <Slider
                                defaultValue={Number(i.default_value || 0)}
                                min={typeof i.min === 'number' ? i.min : 10}
                                max={typeof i.max === 'number' ? i.max : 10}
                                step={typeof i.step === 'number' ? i.step : 1}
                                onChange={(v) => {
                                  setFormData({
                                    ...formData,
                                    [i.key]: v,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {i.type === 'inputNumber' && (
                          <div key={i.key}>
                            <Input
                              // value={formData[i.key]}
                              defaultValue={typeof i.default_value === 'number' ? i.default_value : -1}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  [i.key]: +e.target.value,
                                });
                              }}
                            />
                          </div>
                        )}
                        {i.type === 'checkbox' && (
                          <div>
                            <Checkbox
                              defaultChecked={!!i.default_value}
                              checked={formData[i.key]}
                              onCheckedChange={(v) => {
                                setFormData({
                                  ...formData,
                                  [i.key]: !!v,
                                });
                              }}
                            ></Checkbox>
                          </div>
                        )}
                        {i.type === 'file' && (
                          <div key={i.key}>
                            <Input
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                  setFormData({
                                    ...formData,
                                    [i.key]: file,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    [i.key]: null,
                                  });
                                }
                              }}
                            />
                          </div>
                        )}
                        {i.type === 'modelSelect' && (
                          <div>
                            <Select
                              value={formData[i.key]}
                              onValueChange={(v) => {
                                setFormData({
                                  ...formData,
                                  ['model']: v,
                                });
                              }}
                            >
                              <>
                                {i.options[type]?.map((option) => <SelectOption key={option} value={option} label={option}></SelectOption>)}
                              </>
                            </Select>
                          </div>
                        )}
                        {i.type === 'stylefilterSelect' && (
                          <div>
                            <Select
                              value={formData[i.key]}
                              onValueChange={(v) => {
                                setFormData({
                                  ...formData,
                                  [i.key]: v ? +v : null,
                                });
                              }}
                            >
                              <>
                                <SelectOption key={null} value={null} label={'--'}></SelectOption>
                                {afterStyleFilterFilterList.map((i) => (
                                  <SelectOption key={i.id} value={i.id} label={i.name}></SelectOption>
                                ))}
                              </>
                            </Select>
                          </div>
                        )}
                        {/* {i.type === 'genreStylefilterSelect' && (
                        <div>
                          <Select
                            value={formData[i.key]}
                            onValueChange={(v) => {
                              setFormData({
                                ...formData,
                                [i.key]: v ? +v : null,
                              });
                            }}
                          >
                            <>
                              <SelectOption key={null} value={null} label={'--'}></SelectOption>
                              {genreStylefilter.map((i) => (
                                <SelectOption key={i.id} value={i.id} label={i.name}></SelectOption>
                              ))}
                            </>
                          </Select>
                        </div>
                      )} */}
                        {i.type === 'select' && (
                          <div>
                            <Select
                              defaultValue={String(i.default_value || '')}
                              value={formData[i.key]}
                              onValueChange={(v) => {
                                if (v !== '') {
                                  setFormData({
                                    ...formData,
                                    [i.key]: v,
                                  });
                                }
                              }}
                            >
                              <>
                                {i.options?.map((option) => {
                                  if (option === null) return <SelectOption key={option} value={option} label={'--'}></SelectOption>;
                                  return <SelectOption key={option} value={option} label={option}></SelectOption>;
                                })}
                              </>
                            </Select>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </form>
        )}
      </div>
      <div className="flex-1 h-lvh overflow-y-auto">
        <div className="h-4/6">{!generatorTextLoading && <AudioList />}</div>
        <div className="h-2/6  overflow-y-auto">
          <Button
            onClick={() => {
              clipboard.copy(
                JSON.stringify(
                  {
                    id: audioDetail.id,
                    prompt: audioDetail.prompts,
                    duration: audioDetail.duration,
                    model_version: audioDetail.model_version,
                    stylefilter: audioDetail.stylefilter,
                    ...audioDetail.metadata,
                  },
                  null,
                  4,
                ),
              );
              toast.info('Copied to Clipboard');
            }}
            className="my-2"
          >
            Copy
          </Button>
          <div>id: {audioDetail.id}</div>
          <div>prompt: {audioDetail.prompts}</div>
          <div>storage_path: {audioDetail.storage_path}</div>
          <div>duration: {audioDetail.duration}</div>
          <div>model_version: {audioDetail.model_version}</div>
          <div>stylefilter: {audioDetail.stylefilter}</div>
          <pre>{JSON.stringify(audioDetail.metadata, null, 4)}</pre>
        </div>
      </div>
    </div>
  );
};

export default SuperTester;
